/**
 * The record lane's Feasibility section (SA-1076): `FeasibilityPanel` in its
 * section chrome, told whether the record's process waits on a feasibility
 * result so it can say a result here ends that step.
 *
 * The process read is the band's own query (`useRecordProcess`, one cache
 * entry), refetched by the band after every write the page reports; this
 * mount lets `OrderDetail` keep calling no React Query hook itself (SA-397).
 */
import { FeasibilityPanel } from '@/components/orders/FeasibilityPanel'
import { useRecordProcess } from '@/hooks/useProcess'
import type { FeasibilityPayload, OrderFeasibilityState } from '@/types/commerce'
import { feasibilityAwait } from './feasibilityAwait'
import { ownedSections } from './laneDefaults'

export interface FeasibilitySectionProps {
  orderId: string
  orderType: string
  outcome?: string | null
  focused: boolean
  getFeasibility: (orderId: string) => Promise<OrderFeasibilityState>
  recordFeasibility: (orderId: string, payload: FeasibilityPayload) => Promise<OrderFeasibilityState>
  selectScenario: (orderId: string, scenarioId: string) => Promise<OrderFeasibilityState>
  onChanged: () => void
}

export function FeasibilitySection({ orderId, orderType, ...rest }: FeasibilitySectionProps) {
  const record = useRecordProcess(orderType === 'quote' ? orderId : undefined)
  const owned = ownedSections(record.data ?? null).has('feasibility')
  return (
    <FeasibilityPanel chrome="section" defaultOpen={owned} activeTaskFor={owned ? orderId : null} orderId={orderId} orderType={orderType} awaiting={feasibilityAwait(record.data)} {...rest} />
  )
}
